/**
 * @desc 分页查询CommissionManagement列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.CommissionManagementPagingQueryParameters>): Promise<BaseResponse<defs.PageBean<Array<defs.CommissionManagement>>>> {
  return fetch({
    url: config.API_HOST + '/commissionManage/pageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
